import { SimpleTask } from 'aos-services/src/services/tasks/types/task/SimpleTask'
import { TaskTemplate } from 'aos-services/src/services/tasks/types/task/TaskTemplate'
import { PropsListEntry } from 'aos-ui/src/components/list/PropsList'
import { TFunction } from 'i18next'

export const simpleTaskPropertyList =
    (_: TFunction) =>
    (_: SimpleTask | TaskTemplate<SimpleTask>): PropsListEntry[] => []
